import { Badge, Card, Heading } from '@autoplan/web-ui'
import { useNavigate } from 'react-router-dom'

type MyCarCardProps = {
  vehicle: {
    regNumber: string
    model: string
    brand: string
    engineType: string
    imageUrl: string
    status: 'active' | 'inactive' | 'maintenance'
  }
}

export const MyCarCard = ({ vehicle }: MyCarCardProps) => {
  const navigate = useNavigate()

  return (
    <Card className="ap:overflow-hidden ap:flex ap:flex-row" onClick={() => navigate(`/vehicles/${vehicle.regNumber}`)}>
      <div className="ap:flex ap:bg-surface-accent-dark-hover ap:w-8xl">{/* TODO: Image of car */}</div>
      <div className="ap:flex ap:flex-1 ap:px-2xl ap:py-lg ap:justify-between ap:gap-xl">
        <div className="ap:flex ap:min-w-0 ap:items-center ap:gap-lg">
          <div className="ap:min-w-0">
            <p className="ap:truncate ap:pt-2xs ap:text-sm ap:text-content-secondary">{vehicle.regNumber}</p>
            <Heading size="md" className="ap:truncate">
              {vehicle.brand} {vehicle.model}
            </Heading>
            <p className="ap:truncate ap:pt-2xs ap:text-sm ap:text-content-secondary">{vehicle.engineType}</p>
          </div>
        </div>
        <div className="ap:flex ap:items-start">
          <Badge variant="success">{vehicle.status}</Badge>
        </div>
      </div>
    </Card>
  )
}
